"use client";

import type { ReactNode } from "react";
import { ChevronDown, Loader2 } from "lucide-react";

export type SelectOption = {
  value: string;
  label: string;
};

type SelectProps = {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  icon?: ReactNode;
  ariaLabel?: string;
};

export function Select({
  id,
  value,
  onChange,
  options,
  disabled = false,
  isLoading = false,
  className = "",
  icon,
  ariaLabel,
}: SelectProps) {
  return (
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || isLoading}
        aria-label={ariaLabel}
        aria-busy={isLoading || undefined}
        className={`h-10 appearance-none rounded-md border border-[#2a475e] bg-[#16202d] py-2 pl-3 pr-10 text-sm text-white outline-none focus:border-[#66c0f4] disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#8f98a0]">
        {isLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
        ) : (
          icon ?? <ChevronDown className="h-4 w-4" aria-hidden="true" />
        )}
      </span>
    </div>
  );
}
